import script from "./ProductViewToggle.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductViewToggle.vue?vue&type=script&setup=true&lang=js"

import "./ProductViewToggle.vue?vue&type=style&index=0&id=3eb2278f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eb2278f"]])

export default __exports__